import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import type { HeadingsDefaultStyleProps } from 'hb-builder/components/UIComponents/shared/common/Root/utils/headingsDefaultStyle';
import { headingsDefaultStyle } from 'hb-builder/components/UIComponents/shared/common/Root/utils/headingsDefaultStyle';

interface ResetStyledRootProps {
  $breakpoint: HeadingsDefaultStyleProps['breakpoint'];
  $unit: HeadingsDefaultStyleProps['unit'];
  $linkColor: string;
}

const ResetStyledRoot = styled(Box).attrs(() => ({
  color: 'black',
  flex: 1,
  flexDirection: 'column',
  fontSize: 2,
  width: '100%',
}))<ResetStyledRootProps>`
  ${(props) =>
    headingsDefaultStyle({
      breakpoint: props.$breakpoint,
      unit: props.$unit,
    })}
  *::selection {
    // selection color has to be transparent to display underline/strikethrough style on Chrome.
    background: rgba(71, 51, 255, 0.4) !important;
    color: initial !important;
  }

  a {
    color: ${({ $linkColor }) => $linkColor};
    text-decoration: underline;
  }

  strong {
    font-weight: bold;
  }

  em {
    font-style: italic;
  }

  s {
    text-decoration: line-through;
  }

  u {
    text-decoration: underline;
  }
`;

export default ResetStyledRoot;
